import { addDestroyableEventListener, createElementFromTemplate } from '../../dom';
const defaultAgIconAsc = '<span class="ag-icon ag-icon-asc" unselectable="on"></span>';
const defaultAgIconDesc = '<span class="ag-icon ag-icon-desc" unselectable="on"></span>';
const defaultAgIconUnSort = '<span class="ag-icon" unselectable="on"></span>';
const TEMPLATE = `
    <span class="ag-header-icon ag-sort-order ag-hidden"
          aria-hidden="true">
    </span>
    <span class="ag-header-icon ag-sort-ascending-icon ag-hidden"
          aria-hidden="true">
        ${defaultAgIconAsc}
    </span>
    <span class="ag-header-icon ag-sort-descending-icon ag-hidden"
          aria-hidden="true">
        ${defaultAgIconDesc}
    </span>
        <span class="ag-header-icon ag-sort-unsort-icon ag-hidden"
          aria-hidden="true">
        ${defaultAgIconUnSort}
    </span>
    `;
export const EVENT_SORT_CHANGED = 'sortChanged';
export const EVENT_SORT_REQUESTED = 'sortRequested';
// eslint-disable-next-line @typescript-eslint/naming-convention
export function AgSortingHeader(base) {
    return class extends base {
        init(params) {
            super.init(params);
            if (!Boolean(this.destroyFonctions)) {
                this.destroyFonctions = [];
            }
            this.eLabel = this.getGui().querySelector('div.ag-header-cell-label');
            if (Boolean(this.eLabel)) {
                this.setupSortingIcons(params);
                this.setupSort(params);
            }
            else {
                throw new Error(
                // eslint-disable-next-line max-len
                '[AgSortingHeader] Decorated class must contain in GUI element the following selector \'div.ag-header-cell-label\' in order to be extended with the sorting behavior.');
            }
        }
        destroy() {
            if (Boolean(this.destroyFonctions)) {
                this.destroyFonctions.forEach((fnc) => fnc());
            }
        }
        setupSortingIcons(params) {
            const gui = this.getGui();
            this.eLabel.append(...createElementFromTemplate(TEMPLATE));
            this.eSortOrder = gui.querySelector('span.ag-sort-order');
            this.eSortAsc = gui.querySelector('span.ag-sort-ascending-icon');
            this.eSortDesc = gui.querySelector('span.ag-sort-descending-icon');
            this.eSortUnsort = gui.querySelector('span.ag-sort-unsort-icon');
            this.setIcons(params);
            this.eSortAsc.classList.toggle('ag-hidden', !params.column.isSortAscending());
            this.eSortDesc.classList.toggle('ag-hidden', !params.column.isSortDescending());
            this.eSortUnsort.classList.toggle('ag-hidden', params.column.isSorting());
        }
        setupSort(params) {
            const clickHandler = this.sort.bind(this, params);
            const sortChangedHandler = this.onSortChanged.bind(this, params);
            const multiSortOrderHandler = this.setMultiSortOrder.bind(this, params);
            this.destroyFonctions.push(addDestroyableEventListener(this.eLabel, 'click', clickHandler), addDestroyableEventListener(params.column, EVENT_SORT_CHANGED, sortChangedHandler), addDestroyableEventListener(params.api, EVENT_SORT_CHANGED, multiSortOrderHandler), addDestroyableEventListener(document.body, EVENT_SORT_REQUESTED, sortChangedHandler));
        }
        sort(params, event) {
            const isMultiSort = event.shiftKey;
            params.progressSort(isMultiSort);
        }
        onSortChanged(params) {
            this.setIcons(params);
            this.eSortAsc.classList.toggle('ag-hidden', !params.column.isSortAscending());
            this.eSortDesc.classList.toggle('ag-hidden', !params.column.isSortDescending());
            this.eSortUnsort.classList.toggle('ag-hidden', params.column.isSorting());
        }
        setIcons(params) {
            var _a;
            const colIcons = (_a = params.column.getColDef()) === null || _a === void 0 ? void 0 : _a.icons;
            this.eSortAsc.innerHTML = '';
            this.eSortAsc.innerHTML = this.getIconOrDefault(colIcons === null || colIcons === void 0 ? void 0 : colIcons.sortAscending, defaultAgIconAsc);
            this.eSortDesc.innerHTML = '';
            this.eSortDesc.innerHTML = this.getIconOrDefault(colIcons === null || colIcons === void 0 ? void 0 : colIcons.sortDescending, defaultAgIconDesc);
            this.eSortUnsort.innerHTML = '';
            this.eSortUnsort.innerHTML = this.getIconOrDefault(colIcons === null || colIcons === void 0 ? void 0 : colIcons.sortUnSort, defaultAgIconUnSort);
        }
        getIconOrDefault(...icons) {
            var _a;
            let foundIcon = '';
            for (const icon of icons) {
                foundIcon = typeof icon === 'string' ? icon : (_a = icon === null || icon === void 0 ? void 0 : icon()) !== null && _a !== void 0 ? _a : '';
                if (Boolean(foundIcon)) {
                    break;
                }
            }
            return foundIcon;
        }
        setMultiSortOrder(params) {
            const columnsWithSortingOrdered = params.columnApi
                .getColumns()
                .filter((col) => col.getSort())
                .sort((colA, colB) => colA.getSortIndex() - colB.getSortIndex());
            const indexThisCol = columnsWithSortingOrdered.indexOf(params.column);
            const moreThanOneColSorting = columnsWithSortingOrdered.length > 1;
            const showIndex = params.column.isSorting() && moreThanOneColSorting;
            this.eSortOrder.classList.toggle('ag-hidden', !showIndex);
            const colSortingOrder = (indexThisCol + 1).toString();
            this.eSortOrder.innerText = indexThisCol >= 0 ? colSortingOrder : '';
        }
    };
}
